/* ================================================================
   DIA BY NADIA — Custom Sections JS
   ================================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ── COLLECTION TABS ──────────────────────────────────── */
    document.querySelectorAll('.dbn-coll-tabs').forEach(function (section) {
      var pills  = section.querySelectorAll('.dbn-pill');
      var panels = section.querySelectorAll('.dbn-panel');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var id = pill.dataset.dbnTab;
          pills.forEach(function (p) { p.classList.remove('dbn-active'); p.setAttribute('aria-selected', 'false'); });
          panels.forEach(function (p) { p.classList.remove('dbn-active'); });
          pill.classList.add('dbn-active');
          pill.setAttribute('aria-selected', 'true');
          var panel = section.querySelector('[data-dbn-panel="' + id + '"]');
          if (panel) panel.classList.add('dbn-active');
        });
      });
    });

    /* ── PRODUCT FILTER TABS ──────────────────────────────── */
    document.querySelectorAll('.dbn-new-in').forEach(function (section) {
      var btns  = section.querySelectorAll('.dbn-filter-btn');
      var cards = section.querySelectorAll('.dbn-pc');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('dbn-active'); });
          btn.classList.add('dbn-active');
          var tag = btn.dataset.filter;
          cards.forEach(function (card) {
            if (tag === 'all') {
              card.classList.remove('dbn-pc--hidden');
            } else {
              var tags = (card.dataset.tags || '').split(',').map(function (t) { return t.trim(); });
              if (tags.indexOf(tag) > -1) {
                card.classList.remove('dbn-pc--hidden');
              } else {
                card.classList.add('dbn-pc--hidden');
              }
            }
          });
        });
      });
    });

    /* ── SIZE SELECT → update Quick Add variant ───────────── */
    document.addEventListener('click', function (e) {
      var sz = e.target.closest('.dbn-sz');
      if (!sz || sz.classList.contains('dbn-sz-na')) return;
      var row = sz.closest('.dbn-pc__sz-row');
      if (row) row.querySelectorAll('.dbn-sz').forEach(function (s) { s.classList.remove('dbn-sz-on'); });
      sz.classList.add('dbn-sz-on');
      var panel = sz.closest('.dbn-pc__sizes');
      if (panel) {
        var qadd = panel.querySelector('.dbn-qadd');
        if (qadd) qadd.dataset.vid = sz.dataset.vid;
      }
    });

    /* ── QUICK ADD TO CART ────────────────────────────────── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.dbn-qadd');
      if (!btn) return;
      e.preventDefault();
      var vid = btn.dataset.vid;
      if (!vid) {
        var prev = btn.textContent;
        btn.textContent = 'Pick a size first';
        setTimeout(function () { btn.textContent = prev; }, 1800);
        return;
      }
      var orig = btn.textContent;
      btn.textContent = 'Adding\u2026';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        btn.textContent = '\u2713 Added!';
        dbnRefreshCart();
        setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2200);
      })
      .catch(function () {
        btn.textContent = 'Error \u2014 retry';
        btn.disabled = false;
      });
    });

    /* ── CART COUNT REFRESH ───────────────────────────────── */
    function dbnRefreshCart() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          /* Dawn's cart bubble uses cart-icon-bubble custom element */
          document.querySelectorAll('cart-icon-bubble').forEach(function (el) {
            var span = el.querySelector('.cart-count-bubble span:first-child');
            if (span) span.textContent = d.item_count;
          });
          /* Generic fallback */
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = d.item_count;
          });
          /* Dispatch event Dawn listens to */
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {});
    }

    /* ── WISHLIST ─────────────────────────────────────────── */
    var WL = 'dbn_wl';
    function getWL() { try { return JSON.parse(localStorage.getItem(WL) || '[]'); } catch (e) { return []; } }
    function putWL(a) { try { localStorage.setItem(WL, JSON.stringify(a)); } catch (e) {} }

    getWL().forEach(function (id) {
      document.querySelectorAll('.dbn-pc__wish[data-pid="' + id + '"]').forEach(function (b) {
        b.classList.add('dbn-wished');
      });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.dbn-pc__wish[data-pid]');
      if (!btn) return;
      var list = getWL();
      var id   = btn.dataset.pid;
      var idx  = list.indexOf(id);
      if (idx > -1) { list.splice(idx, 1); btn.classList.remove('dbn-wished'); }
      else          { list.push(id);        btn.classList.add('dbn-wished'); }
      putWL(list);
    });

    /* ── TESTIMONIALS SLIDER ──────────────────────────────── */
    document.querySelectorAll('.dbn-testi').forEach(function (section) {
      var track  = section.querySelector('.dbn-testi__track');
      var slides = section.querySelectorAll('.dbn-testi__slide');
      var dots   = section.querySelectorAll('.dbn-testi-dot');
      if (!track || slides.length < 2) return;
      var cur = 0;

      function goTo(i) {
        cur = ((i % slides.length) + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('dbn-active', j === cur); });
      }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      setInterval(function () { goTo(cur + 1); }, 5000);
      goTo(0);
    });

    /* ── COUNTDOWN TIMER ──────────────────────────────────── */
    document.querySelectorAll('.dbn-countdown[data-end]').forEach(function (el) {
      var end = new Date(el.dataset.end).getTime();
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          el.innerHTML = '<span style="font-size:1.2rem;letter-spacing:.1em;text-transform:uppercase;opacity:.6">Drop is Live!</span>';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000)  / 60000);
        var s = Math.floor((diff % 60000)    / 1000);
        var dd = el.querySelector('.dbn-cd-d');
        var dh = el.querySelector('.dbn-cd-h');
        var dm = el.querySelector('.dbn-cd-m');
        var ds = el.querySelector('.dbn-cd-s');
        if (dd) dd.textContent = pad(d);
        if (dh) dh.textContent = pad(h);
        if (dm) dm.textContent = pad(m);
        if (ds) ds.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });

  }); /* end ready */

})();
